
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/knowledge-base/[category]",
      function () {
        return require("private-next-pages/knowledge-base/[category]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/knowledge-base/[category]"])
      });
    }
  